import { useModal } from '../components/Modals/ModalContext';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';

export const useAuthModal = () => {
  const { openModal } = useModal();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const requireAuth = useCallback(() => {
    if (!isAuthenticated) {
      openModal('login');
      return false;
    }
    return true;
  }, [isAuthenticated, openModal]);

  const openLoginModal = useCallback(() => openModal('login'), [openModal]);
  const openRegisterModal = useCallback(() => openModal('register'), [openModal]);

  return {
    isAuthenticated,
    requireAuth,
    openLoginModal,
    openRegisterModal,
  };
}; 